import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCqQN5YSBNOtAgWI7zDY4as_Luc-Es0hSI",
  authDomain: "istesivas-62257.firebaseapp.com",
  projectId: "istesivas-62257",
  storageBucket: "istesivas-62257.firebasestorage.app",
  messagingSenderId: "459813498990",
  appId: "1:459813498990:web:b5c5cda3f975f38c4f367f",
  measurementId: "G-BE5J6KKT9K"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
